import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Button } from "../Button";
import { Inline } from "../Inline";
export var ToastButton = function ToastButton(props) {
  return /*#__PURE__*/React.createElement(Button, _extends({
    size: "small",
    variant: "link"
  }, props));
};
export var ToastButtonGroup = function ToastButtonGroup(props) {
  return /*#__PURE__*/React.createElement(Inline, _extends({
    gap: 12
  }, props));
};